import { PageInfoModel } from '../../../shared/data/models/page-info.model';
import { SingleNotificationState } from './single-notification.state';

export interface NotificationState {
  notification: SingleNotificationState[];
  pageInfo: PageInfoModel;
  loading: boolean;
  error: string;
}

export const initialNotificationState: NotificationState = {
  notification: [],
  pageInfo: null,
  loading: false,
  error: ''
};
